import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { TextInput, Dropdown } from "hesus-ui-kit";
import DatePicker from "react-multi-date-picker";
import * as moment from "moment";
import { ListContent, GridRow } from "./AddEditSpecificCondition.styled";
import {
  getDatePickerFormat,
  getDateFormat,
  getCalendarLocale,
} from "@utils/datePickerUtils";
import { labelStyles, labelStylesError } from "@utils/extra-style";

const ParametersFormat = (props) => {
  const { t, parametersValue, parametersError, data, addParameters } = props;

  const [parameterData, setParameterData] = useState([]);
  const [pattern, setPattern] = useState([]);

  const fetchInfo = () => {
    if (data && data.parameters !== "") {
      const params = JSON.parse(data.parameters);
      setParameterData({ ...params.parameters, nl: "nl" });
      const patternKeys = params?.formPattern?.split(/[%%]/);
      setPattern(patternKeys?.filter((e) => e !== " " && e !== ""));
    }
  };

  useEffect(() => {
    fetchInfo();
  }, []);

  let newLine = -1;

  return (
    <ListContent>
      <GridRow>
        {Object.keys(parameterData).length > 0 &&
          pattern &&
          pattern.map((key, index) => {
            if (key === "nl") newLine = index + 1;
            return (
              <React.Fragment key={"ParametersFormat" + index}>
                {Object.hasOwn(parameterData, key) && (
                  <>
                    {parameterData[key].type === "float" && (
                      <TextInput
                        type="text"
                        label={t(parameterData[key].label)}
                        name="quote-specific-condition-text-input"
                        id={`center-product-price-title-${t(data.id)}`}
                        value={parametersValue ? parametersValue[key] : ""}
                        onChange={(e) => {
                          addParameters(
                            data.parent ? data.parent.id : data.id,
                            data,
                            key,
                            e.target.value
                          );
                        }}
                        isFloat
                        containerStyles={{
                          marginTop: "23px",
                          marginBottom: "10px",
                          gridColumnStart: newLine === index ? "1" : "inherit",
                        }}
                        labelStyles={{
                          lineHeight: "19px !important",
                          fontWeight: "bold",
                          color:
                            parametersError && parametersError[key] === 1
                              ? "red"
                              : "#1bace4",
                        }}
                        inputStyles={{
                          fontSize: "16px",
                          height: "auto",
                          width: "100%",
                          borderRadius: "4px",
                          padding: "0.4rem 0.625rem",
                          border:
                            parametersError && parametersError[key] === 1
                              ? "1px solid red !important"
                              : "1px solid #767676 !important",
                          boxSizing: "border-box",
                          boxShadow: "none",
                          lineHeight: "1.40rem",
                        }}
                        placeholder={t(parameterData[key].placeholder)}
                      />
                    )}
                    {parameterData[key].type === "choice" && (
                      <Dropdown
                        id={`quote-specific-condition-${data.id}`}
                        label={t(parameterData[key].label)}
                        name="quote-specific-condition-choice"
                        value={parametersValue ? parametersValue[key] : ""}
                        onChange={(e) => {
                          addParameters(
                            data.parent ? data.parent.id : data.id,
                            data,
                            key,
                            e.value
                          );
                        }}
                        defaultOption={t(parameterData[key].placeholder)}
                        options={parameterData[key].choices.map((data) => {
                          return { label: data, value: data };
                        })}
                        containerStyles={{
                          marginBottom: "10px",
                          gridColumnStart: newLine === index ? "1" : "inherit",
                        }}
                        labelStyles={
                          parametersError && parametersError[key] === 1
                            ? labelStylesError
                            : labelStyles
                        }
                        inputStyles={{
                          background: "#FFFFFF",
                          border:
                            parametersError && parametersError[key] === 1
                              ? "1px solid red !important"
                              : "1px solid #767676 !important",
                        }}
                      />
                    )}
                    {parameterData[key].type === "date" && (
                      <div
                        style={{
                          marginBottom: "10px",
                          gridColumnStart: newLine === index ? "1" : "inherit",
                        }}
                      >
                        <label
                          style={{
                            fontSize: "1rem",
                            fontFamily: "Lato",
                            lineHeight: 1,
                            textTransform: "initial",
                            fontWeight: "bold",
                            color:
                              parametersError && parametersError[key] === 1
                                ? "red"
                                : "#1bace4",
                          }}
                          htmlFor="add-quote-specific-condition-date"
                        >
                          {t(parameterData[key].label)}
                        </label>
                        <DatePicker
                          inputClass={
                            parametersError && parametersError[key] === 1
                              ? "add-quote-specific-condition__date-input-error"
                              : "add-quote-specific-condition__date-input"
                          }
                          containerClassName="add-quote-specific-condition__datepicker-container"
                          type="text"
                          label={t(parameterData[key].label)}
                          name="add-quote-specific-condition-date"
                          id={`add-quote-specific-condition-date-${data.id}`}
                          calendarPosition="bottom-center"
                          isFloat
                          onChange={(e) => {
                            addParameters(
                              data.parent ? data.parent.id : data.id,
                              data,
                              key,
                              moment(e.toDate()).format("YYYY-MM-DD")
                            );
                          }}
                          format={getDatePickerFormat()}
                          locale={getCalendarLocale()}
                          value={
                            parametersValue
                              ? getDateFormat(
                                  parametersValue[key],
                                  "YYYY-MM-DD"
                                )
                              : ""
                          }
                          containerStyles={{
                            marginBottom: "10px",
                            gridColumnStart:
                              newLine === index
                                ? "1 !important"
                                : "inherit !important",
                          }}
                          placeholder={t(parameterData[key].placeholder)}
                        />
                      </div>
                    )}
                  </>
                )}
              </React.Fragment>
            );
          })}
      </GridRow>
    </ListContent>
  );
};

ParametersFormat.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  addParameters: PropTypes.func.isRequired,
  parametersValue: PropTypes.string.isRequired,
  parametersError: PropTypes.string.isRequired,
};

export default withTranslation()(ParametersFormat);
